import React, { PureComponent, Fragment } from 'react';
import { injectIntl, type WrappedComponentProps } from 'react-intl-next';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import TextField from '@atlaskit/textfield';
import { ErrorMessage } from '@atlaskit/form';
import { token } from '@atlaskit/tokens';

import messages from './messages';
import { type Props, type StateProps, type DispatchProps, type OwnProps } from './types';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const Container = styled.div`
	margin-top: ${token('space.100', '8px')};
`;

class Content extends PureComponent<Props> {
	handleKeyPress = ({ key }: any) => {
		const { onCreate, userEnteredSpaceName } = this.props;
		const containsAtLeastTwoAlphanumericValues = (str: any) => /[a-zA-Z0-9]{2,}/g.test(str);
		if (key === 'Enter' && containsAtLeastTwoAlphanumericValues(userEnteredSpaceName)) {
			onCreate();
		}
	};

	renderAppropriateInvalidMessage = () => {
		const {
			intl: { formatMessage },
			userEnteredSpaceName,
		} = this.props;
		return (
			<ErrorMessage>
				{formatMessage(userEnteredSpaceName.length < 1 ? messages.emptyName : messages.invalidName)}
			</ErrorMessage>
		);
	};

	render() {
		const {
			intl: { formatMessage },
			isCreatingSpace,
			spaceNameInvalid,
			userEnteredSpaceName,
			onSpaceNameChanged,
		} = this.props;

		return (
			<Container>
				<Fragment>
					<TextField
						autoFocus
						isDisabled={isCreatingSpace}
						placeholder={formatMessage(messages.placeholder)}
						onChange={(input: any) => onSpaceNameChanged(input.target.value)}
						onKeyPress={this.handleKeyPress}
						isInvalid={spaceNameInvalid}
						value={userEnteredSpaceName}
						label=""
						maxLength={80}
						data-test-id="confluence-project-pages.post-expand.create-space-modal.name-entry"
					/>
					{spaceNameInvalid && this.renderAppropriateInvalidMessage()}
				</Fragment>
			</Container>
		);
	}
}

export default injectIntl<'intl', WrappedComponentProps & StateProps & DispatchProps & OwnProps>(
	Content,
);
